export const CONST_ACKNOWLEDGE_WALLET_RISK = 'ackWalletRisk';
export const CONST_ACKNOWLEDGE_GA = 'ackGA';
export const CONST_GA_ACTION = {
  ACCEPT: '1',
  REJECT: '2',
};
